import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Kitchen from "./Pages/Kitchen";
import Reception from "./Pages/Reception";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Store";
import Login from "./Pages/Login";
import Report from "./Pages/Report";
import ChangePassword from "./Pages/ChangePassword";
import CheckInModel from "./Components/ViewModals/CheckInModel";
import CheckOutModel from "./Components/ViewModals/CheckOutModel";
import DeliveryModule from "./Pages/DeliveryModule";
import DeliveryRooms from "./Pages/DeliveryRooms";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/kitchen" element={<Kitchen />} />
          <Route path="/reception" element={<Reception />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reports" element={<Report />} />
          <Route path="changepassword" element={<ChangePassword />} />
          <Route path="deliverymodule" element={<DeliveryModule />} />
          <Route path="deliveryrooms" element={<DeliveryRooms />} />
        </Routes>
      </Router>
    </Provider>
  </React.StrictMode>
);
